// extracted by mini-css-extract-plugin
export var container = "Label-module--container--9f90e";
export var inline = "Label-module--inline--d5352";
export var label = "Label-module--label--25c25";